import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { tournamentPrizePool } from '@/common/config/onboarding-config';
import {
  H2,
  StringSmall,
  StringXSmall,
} from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import backgroundPng from '/img/leagues/banner.png';
import ackngroundWebp from '/img/leagues/banner.webp';

interface ArenaBannerProps {
  className?: string;
}
const ArenaBanner: FC<ArenaBannerProps> = ({ className }) => {
  const { t } = useTranslation();
  const userLeague =
    useAppSelector((state) => state.leagues.currentLeagueId) ?? 0;

  if (!userLeague) return null;

  if (tournamentPrizePool.usd <= 0) return null;

  const isLocked = userLeague < 2; // Steel league id is 3

  console.debug('ArenaBanner render', { userLeague, isLocked });

  return (
    <div
      className={cn(
        'pr-6 pl-4 rounded-lg overflow-clip relative h-20 bg-main-bg z-0 flex gap-2',
        className,
      )}
    >
      <Picture
        img={backgroundPng}
        webp={ackngroundWebp}
        alt="arena banner"
        className="absolute right-0 h-full top-0 z-[-1]"
      />
      <div
        className={cn(
          'size-[12.875rem] opacity-[0.58] absolute top-2.5 -left-[3.125rem] rounded-full z-[-1]',
          isLocked ? 'bg-white blur-[110px]' : 'bg-[#50AF95] blur-[42px]',
        )}
      />
      <div
        className={cn(
          'size-44 absolute right-0 -bottom-[1.5625rem] rounded-full z-[-1]',
          isLocked
            ? 'bg-white blur-[90px]'
            : 'bg-[#50AF95] blur-[42px] opacity-[0.58] ',
        )}
      />

      <div className="flex flex-col gap-1 items-start pt-3 flex-1 ">
        <StringSmall weight="bold" className="!truncate">
          {t(isLocked ? 'Unlock the Arena Prize Pool' : 'Arena Prize Pool')}
        </StringSmall>
        <H2 weight="bold">$ {tournamentPrizePool.usd}</H2>
        <StringXSmall
          className={cn(
            'truncate mt-1',
            isLocked
              ? 'text-[#FFE6E6] [text-shadow:0_0.75px_9px_#FE2C55]'
              : 'text-white/60',
          )}
        >
          {t(
            isLocked
              ? 'Requirements Steel League or higher'
              : 'Rewards every week!',
          )}
        </StringXSmall>
      </div>

      <Picture
        img={
          isLocked
            ? '/img/leagues/lock-prize.png'
            : '/img/leagues/unlock-prize.png'
        }
        webp={
          isLocked
            ? '/img/leagues/lock-prize.webp'
            : '/img/leagues/unlock-prize.webp'
        }
        className="size-20 aspect-square"
        alt="icon"
      />
    </div>
  );
};

export default ArenaBanner;
